import React, { ReactNode } from 'react';

// A band of the page with main's padding and column (DESIGN_SYSTEM.md, section 4); bands
// alternate between the page and secondary backgrounds, as on the homepage.
export function Band({ id, tone = 'page', children }: { id: string; tone?: 'page' | 'secondary'; children: ReactNode }) {
  return (
    <section id={id} className={`relative py-24 md:py-36 ${tone === 'secondary' ? 'bg-background-secondary' : ''}`}>
      <div className="max-w-wide mx-auto px-6 sm:px-10 md:px-12">{children}</div>
    </section>
  );
}

// Fades a block up once its section is revealed, with main's timing.
export const reveal = (isVisible: boolean) => `opacity-0 ${isVisible ? 'animate-fade-up' : ''}`;

export default Band;
